import { createUseStyles } from '@glu/theming';
import React from 'react';
import { CaretRightIcon } from '@glu/icons-react';
import classnames from 'classnames';
import styles from './Breadcrumbs.styles';
import { PanelOption, Path } from './Dropdown';
import { PanelActions } from './Panel';

const useStyles = createUseStyles(styles);

interface Props {
  /** flag to indicate if we are using dark mode */
  dark?: boolean;
  /** handler that is called when a breadcrumb option is selected */
  onStepSelect?(value?: PanelOption): void;
  /** array containing breadcrumb paths */
  path: Path[];
  setParentName: PanelActions['setParentName'];
  setPath: PanelActions['setPath'];
}

const Breadcrumbs = ({ dark, onStepSelect, path, setParentName, setPath }: Props) => {
  const classes = useStyles();

  return (
    path.length > 0 && (
      <div className={classnames(classes.root, { [classes.dark]: dark })}>
        <button
          className={classes.breadcrumb}
          data-qa="breadcrumb-all"
          onClick={() => {
            if (onStepSelect) {
              onStepSelect(undefined);
            } else {
              setParentName(undefined);
            }
            setPath([]);
          }}
          type="button"
        >
          All
        </button>
        {path.map((step, index) => (
          <span key={step.id}>
            {index < path.length - 1 ? (
              <>
                <CaretRightIcon className={classes.caret} width={6} />
                <button
                  className={classes.breadcrumb}
                  data-qa={`breadcrumb-${step.id}`}
                  onClick={() => {
                    if (onStepSelect) {
                      onStepSelect(path[index]);
                    } else {
                      setParentName(path[index].id);
                    }
                    setPath(path.slice(0, index + 1));
                  }}
                  type="button"
                >
                  {step.name}
                </button>
              </>
            ) : (
              <span>
                <CaretRightIcon className={classes.caret} width={6} />
                {step.name}
              </span>
            )}
          </span>
        ))}
      </div>
    )
  );
};

export default Breadcrumbs;
